// extracted by mini-css-extract-plugin
export default {"topNav":"Oca-z","category":"Pca-z","noArrow":"Qca-z","alternative":"Rca-z","topLevelNavItem":"Sca-z","navContainer":"Tca-z","subcategoryHeading":"Uca-z","subcategory":"Vca-z"};